import styled from 'styled-components';

const Headline = styled.div`
	padding-bottom: 0.8rem;
	margin: 0 0 2.5rem;
	border-bottom: 1px solid ${({ theme }) => theme.grayLightExtra};
`;

export default Headline;
